<template>
  <w-icon-wrapper
    :height='20'
    :width='24'
    icon-name='work-company-add-icon'
    view-box='0 0 24 20'
  >
    <g
      id='_31_Firma_Unternehmen_hinzufügen_Icon'
      data-name='31 Firma / Unternehmen hinzufügen_Icon'
      transform='translate(0 -4)'
    >
      <path
        id='Pfad_55742'
        d='M18,4a6,6,0,0,0-5.53,8.33h-.8V4H0V24H20V15.65A6,6,0,0,0,18,4ZM10,22.33H6.67V19H5v3.33H1.67V5.67H10Zm8.33,0h-2.5V19H14.17v3.33h-2.5V14h1.87A5.947,5.947,0,0,0,18,16a1.829,1.829,0,0,0,.33-.02ZM20,13.46A4,4,0,1,1,22,10,3.989,3.989,0,0,1,20,13.46Z'
        data-name='Pfad 55742'
        fill='currentColor'
      />
      <path
        id='Pfad_55743'
        d='M4.167,9a.834.834,0,1,0-.834-.833A.833.833,0,0,0,4.167,9Z'
        data-name='Pfad 55743'
        fill='currentColor'
      />
      <path
        id='Pfad_55744'
        d='M7.5,9a.834.834,0,1,0-.833-.833A.833.833,0,0,0,7.5,9Z'
        data-name='Pfad 55744'
        fill='currentColor'
      />
      <path
        id='Pfad_55745'
        d='M4.167,12.333a.833.833,0,1,0-.834-.833A.833.833,0,0,0,4.167,12.333Z'
        data-name='Pfad 55745'
        fill='currentColor'
      />
      <path
        id='Pfad_55746'
        d='M7.5,12.333a.833.833,0,1,0-.833-.833A.833.833,0,0,0,7.5,12.333Z'
        data-name='Pfad 55746'
        fill='currentColor'
      />
      <path
        id='Pfad_55747'
        d='M4.167,15.667a.834.834,0,1,0-.834-.834A.833.833,0,0,0,4.167,15.667Z'
        data-name='Pfad 55747'
        fill='currentColor'
      />
      <circle
        id='Ellipse_1532'
        cx='0.833'
        cy='0.833'
        data-name='Ellipse 1532'
        fill='currentColor'
        r='0.833'
        transform='translate(6.667 14)'
      />
      <path
        id='Pfad_55748'
        d='M19.494,9.52h-1v-1a.5.5,0,0,0-1,0v1h-1a.5.5,0,0,0,0,1h1v1a.5.5,0,0,0,1,0v-1h1a.5.5,0,0,0,0-1Z'
        data-name='Pfad 55748'
        fill='currentColor'
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconCompanyAdd' };
</script>
